import React from 'react';
import PaymentControlCenter from '../customers/PaymentControlCenter';

const PaymentCenterPage = () => (
  <PaymentControlCenter standalone />
);

export default PaymentCenterPage;
